import findClosestEditableElement from './find-closest-editable-element';
import findPrevTextContent from './find-prev-text-content';
import isBreakElement from '../verifiers/is-break-element';
import getCollapsedNodeAndOffset from './get-collapsed-node-and-offset';

const handlePreviousSiblingBreakingTag = (event) => {
  const [node, offset] = getCollapsedNodeAndOffset();
  if (offset !== 0) return false;
  const relativeParent = findClosestEditableElement(node);
  const prevElementContent = findPrevTextContent(node, relativeParent);

  if (!isBreakElement(prevElementContent)) return false;
  prevElementContent.remove();
  event.preventDefault();
  return true;
};

export default handlePreviousSiblingBreakingTag;
